module.exports = __webpack_public_path__ + "media/img/pay-6-25c28e98acae9cf54aa048fb72114bfd.svg";